import {initReactI18next} from "react-i18next";

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  "en-US": {
    translation: {
      Settings: "Settings",
      "Slow Motion": "Slow Motion",
      "Display Size": "Display Size",
      FPS: "FPS",
      Hide: "Hide",
      Show: "Show",
      Language: "Language",
      "Next Level": "Next Level",
      "Top times:": "Top times:",
      "Last times:": "Last times:",
      "Play With Friends": "Play With Friends",
      Username: "Username",
      Leaderboard: "Leaderboard",
      Player: "Player",
      Time: "Time",
      Logout: "Logout",
      Watch: "Watch",
      play: "Play",
      edit: "Edit",
      menu: "Menu",
      Enabled: "Enabled",
      Disabled: "Disabled",
      "Camera Follows Player": "Camera Follows Player",
    },
  },
  "de-DE": {
    translation: {
      Settings: "Einstellungen",
      "Slow Motion": "Zeitlupe",
      "Display Size": "Anzeigengröße",
      FPS: "FPS",
      Hide: "Verstecken",
      Show: "Anzeigen",
      Language: "Sprache",
      "Next Level": "Nächstes Level",
      "Top times:": "Beste Zeiten:",
      "Last times:": "Letzte Zeiten:",
      Username: "Benutzername",
      Leaderboard: "Bestenliste",
      Player: "Spieler",
      Time: "Zeit",
      Logout: "Ausloggen",
      Watch: "Zuschauen",
      play: "Spielen",
      edit: "Bearbeiten",
      menu: "Menü",
      Enabled: "Aktiviert",
      Disabled: "Deaktiviert",
      "Camera Follows Player": "Kamera folgt Spieler",
    },
  },
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
